import education from 'resources/education'
import packageGalleryItem from '../resources/packageGalleryItem'
import packageGroup from '../resources/packageGroup'
import collections from '../resources/packageGroupCollection'
import packageGroupCollectionGalleryItem from '../resources/packageGroupCollectionGalleryItem'
import packageGroupGalleryItem from '../resources/packageGroupGalleryItem'
import products from '../resources/packageProduct'
import packages from '../resources/packages'
import rule from '../resources/personalizationRule'
import presets from '../resources/presets'
import retailerAddress from '../resources/retailerAddress'
import retailerPeriod from '../resources/retailerPeriod'
import retailerRepresentative from '../resources/retailerRepresentative'
import retailer from '../resources/retailers'
import retailerTag from '../resources/retailerTag'
import retailerYear from '../resources/retailerYear'

export const resources = {
    Education: education,
    Package: packages,
    PackageGalleryItem: packageGalleryItem,
    PackageGroupCollection: collections,
    PackageProduct: products,
    PackageGroup: packageGroup,
    PackageGroupCollectionGalleryItem: packageGroupCollectionGalleryItem,
    PackageGroupGalleryItem: packageGroupGalleryItem,
    Rule: rule,
    Preset: presets,
    Retailer: retailer,
    RetailerRepresentative: retailerRepresentative,
    RetailerPeriod: retailerPeriod,
    RetailerAddress: retailerAddress,
    RetailerTag: retailerTag,
    RetailerYear: retailerYear
}

export type ResourceKey = keyof typeof resources
